<kui-global-spinner shape="CARDIO"></kui-global-spinner>
<router-outlet />
